/* «Nytt arbeid» som figur under KI-avsnittet: det tomme feltet, forespørselen slippes inn, assistenten finner kunde, fartøy,
   28 arbeidsposter og 5 avklaringer – og saken opprettes. Spiller av selv mens den er i bildet, går i ring. */
import { useEffect, useState } from "react";
import { Inert, Stage } from "../Stage";
import { IntakeApp } from "./LosIntake";
import { CASE } from "./losMockData";

const HOST = "workspace.los-marine.no";
const BEATS = [
  { ms: 3200, at: -1 },
  { ms: 3800, at: 0 },
  { ms: 7000, at: 1, toast: ["28 arbeidsposter og 5 avklaringer funnet", "Fra 114 sider spesifikasjon – kundens tekst beholdt urørt"] },
  { ms: 5200, at: 2, toast: ["Arbeidet er opprettet", `#${CASE.number} ${CASE.vessel} · 28 poster · 3 dokumenter · klar for kalkyle`] },
];

const useScript = (active) => {
  const [i, setI] = useState(0);
  useEffect(() => {
    if (!active) return undefined;
    const t = setTimeout(() => setI((x) => (x + 1) % BEATS.length), BEATS[i].ms);
    return () => clearTimeout(t);
  }, [i, active]);
  return BEATS[i];
};

export const WorkspaceMockup = ({ d }) => {
  const [active, setActive] = useState(false);
  const b = useScript(active);
  return (
    <Stage url={b.at >= 1 ? `${HOST}/ny/8f3a` : `${HOST}/ny`} caption={d?.ui?.prototype} height={820} narrowHeight={680} widths={{ fullWidth: 1440 }} testId="tilbod-workspace-mockup" attrs={{ "data-at": b.at }} onActive={setActive}>
      {({ mode }) => (
        <Inert className="h-full">
          <div key={b.at <= 0 ? "hero" : "chat"} className="mb-view-enter h-full">
            <IntakeApp at={b.at} mode={mode} toast={b.toast} />
          </div>
        </Inert>
      )}
    </Stage>
  );
};
